import { Component, OnInit, Input } from '@angular/core';

import * as saveAs from 'file-saver';
import * as FileSaver from 'file-saver';

@Component({
    moduleId: module.id,
    selector: 'visor-pdf',
    templateUrl: './visor.component.html'
})

export class VisorComponent implements OnInit {
    constructor() { }

    @Input() url_factura: string;
    @Input() arc_factura: Blob;
    @Input() nom_factura: string;


    descargar_pdf(archivo, nombre) {
        FileSaver.saveAs(archivo, nombre);
    }


    ngOnInit() {
        this.nom_factura = "";
        this.url_factura = "";
        this.arc_factura = new Blob;
    }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/pdf-viewer/visor.component.ts